import { LicenseInfo } from 'ui';

export const enableProLicenseMUI = () => {
  if (import.meta.env.VITE_MUI_KEY) {
    LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_KEY);
  }
};
